import { defineNotificationCategory } from './types';

export const creditPoolLowDescriptor = defineNotificationCategory('credit_pool_low', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/credits`,
  nonDisableable: true,
  pills: () => ['Credits'],
});
